import React from 'react';

const SoccerIntervalDetailsRow = ({ leagues, event, renderTeams }) => {
  const league = leagues.find((l) => parseInt(l.id) === parseInt(event.leagueId));
  return league && (
    <div className="interval__detail-row">
      <div>{league?.name}</div>
      <div>
        {event.numMatchesScheduled}
        {' '}
        Matches
      </div>
      <div>
        {event.randomMatches
          ? 'Random'
          : renderTeams(event, league)}
      </div>
    </div>
  );
};

export default SoccerIntervalDetailsRow;
